var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBeforeBtn = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 8,
    viewBox: "0 0 18 8",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.638111 3.39645C0.44285 3.59171 0.44285 3.90829 0.638111 4.10355L3.82009 7.28553C4.01535 7.4808 4.33194 7.4808 4.5272 7.28553C4.72246 7.09027 4.72246 6.77369 4.5272 6.57843L1.69877 3.75L4.5272 0.921573C4.72246 0.726311 4.72246 0.409728 4.5272 0.214466C4.33194 0.0192039 4.01535 0.0192039 3.82009 0.214466L0.638111 3.39645ZM17.9844 3.25L0.991665 3.25V4.25L17.9844 4.25V3.25Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBeforeBtn, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/BeforeBtn.1232c675.svg";
export { ForwardRef as ReactComponent };